'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

require('slick-carousel');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var Recommendations = function () {
  function Recommendations(id) {
    (0, _classCallCheck3.default)(this, Recommendations);

    this.wrapper = '.js-recommendations';
    this.url = '/recommendations/products.json';
    this.productId = id;
    this.limit = 25;

    this.getRecs();
  }

  (0, _createClass3.default)(Recommendations, [{
    key: 'getRecs',
    value: function getRecs() {
      var _this = this;

      var url = this.url,
          productId = this.productId,
          limit = this.limit;

      _axios2.default.get(url + '?product_id=' + productId + '&limit=' + limit).then(function (response) {
        var products = response.data.products;

        var filteredProducts = products.filter(function (product) {
          return product.type !== 'Lens';
        });
        _this.appendRecs(filteredProducts);
        return true;
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }, {
    key: 'appendRecs',
    value: function appendRecs(products) {
      var wrapper = this.wrapper;

      var domWrapper = document.querySelector(wrapper);
      var totalRecs = products.length;

      var index = 0;
      if (totalRecs > 0) {
        do {
          if (products[index]) {
            var html = this.gridItemMarkup(products[index]);
            domWrapper.insertAdjacentHTML('beforeend', html);
          }
          index++;
        } while (index < 3 && index < totalRecs);
        this.mobileRecommendationsSlick();
      }
    }
  }, {
    key: 'gridItemMarkup',
    value: function gridItemMarkup(productData) {
      var firstVariant = productData.variants[0];
      var isSoldOut = firstVariant.available ? '' : 'product-item--sold-out';
      var soldOutLabel = isSoldOut ? 'Out of Stock' : '';
      var isOnSale = firstVariant.compare_at_price && firstVariant.compare_at_price > firstVariant.price ? 'product-item--sale' : '';
      var saleLabel = isOnSale ? 'Sale' : '';
      var isPrescription = productData.tags.includes('prescription') || productData.tags.includes('Prescription');
      var quickAdd = isPrescription ? '' : '<a href="#" class="btn-quick-add js-quick-add"><span></span>Quick Add</a>';
      var productImages = '';
      var colorNames = '';
      var isCurrentColorName = '';
      var swatches = '';
      var prices = '';

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = productData.variants[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var variant = _step.value;

          var isCurrent = variant.id === firstVariant.id ? 'class="current-swatch-variant"' : '';
          var isDisabled = variant.available ? '' : 'data-swatch-disabled';
          var imageClass = '';

          if (variant.id === firstVariant.id) {
            imageClass = ' class="current-image-variant"';
          }

          colorNames += '<span style="font-size: 14px; color: #b3a89b !important;" data-vid-color="' + variant.id + '" id="item_color_name_' + productData.title + '" class="' + (variant.id === firstVariant.id ? 'current-color-name' : '') + '">' + variant.option1 + '</span>';

          prices += '<p class="product__prices-item ' + (variant.id === firstVariant.id ? 'current-price-variant' : '') + '" data-vid-price="' + variant.id + '">' + getPricing(variant) + '</p>';

          swatches += '<li ' + isCurrent + ' ' + isDisabled + '><a class="js-product-item-swatch" data-swatch-vid="' + variant.id + '" data-swatch-style="' + productData.title + '" href="#"><span data-handle-name="' + variant.option1.toLowerCase().replace(/ /g, '-') + '"></span></a></li>';

          if (variant.featured_image) {
            productImages += '<span data-bg-src="' + variant.featured_image.src + '" data-image-variant="' + variant.id + '" style="background-image: url(' + variant.featured_image.src + ');"' + imageClass + '></span>';
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var swatchWrapper = '<ul class="list-swatches list-swatches--plp">' + swatches + '</ul>';

      function getPricing(variant) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          return '<ins class="price__amount">\n                  <span class="money">P' + String(Number(variant.price) / 100).replace('.00', '') + '</span>\n                </ins>\n                <del class="price__amount">\n                  <span class="money">P' + String(Number(variant.compare_at_price) / 100).replace('.00', '') + '</span>\n                </del>';
        } else {
          return '<span class="price__amount">\n                  <span class="money">P' + String(Number(variant.price) / 100).replace('.00', '') + '</span>\n                </span>';
        }
      }

      return '<div class="product-listing__item">\n              <div class="js-product-item product-item product-item--fullwidth ' + isSoldOut + ' ' + isOnSale + '">\n                <div class="product-item__inner">\n                  <div class="product__image">\n                    <ul class="list-badges js-list-badges">\n                      <li class="list__badge list-badges__sold">\n                        <small>' + soldOutLabel + '</small>\n                      </li>\n                      <li class="list__badge list-badges__sale">\n                        <small>' + saleLabel + '</small>\n                      </li>\n                    </ul>\n\n                    <a href="' + productData.url + '">\n                      ' + productImages + '\n                    </a>\n                  </div>\n\n                  <div class="product__content">\n                    <div class="product__entry">\n                      <a href="' + productData.url + '">\n                        <h3>' + productData.title + ' ' + colorNames + '</h3>\n                        <div class="product__prices js-product-item-prices">\n                          ' + prices + '\n                        </div>\n                      </a>\n                    </div>\n\n                    <div class="product__actions">\n                      ' + swatchWrapper + '\n                      ' + quickAdd + '\n                    </div>\n                  </div>\n                </div>\n              </div>\n            </div>';
    }
  }, {
    key: 'mobileRecommendationsSlick',
    value: function mobileRecommendationsSlick() {
      var _this2 = this;

      var recWrapper = document.querySelector('.js-recommendations');
      var options = {
        appendArrows: (0, _jquery2.default)('.js-recommendations-navigation'),
        arrows: true,
        draggable: true,
        infinite: true,
        prevArrow: (0, _jquery2.default)('.js-pdp-recommendations-prev'),
        nextArrow: (0, _jquery2.default)('.js-pdp-recommendations-next'),
        slidesToShow: 1,
        slidesToScroll: 1,
        swipe: true,
        responsive: [{
          breakpoint: 1023,
          settings: {
            slidesToShow: 2
          }
        }, {
          breakpoint: 767,
          settings: {
            slidesToShow: 1
          }
        }]
      };
      var delay = 250;
      var timeout = false;

      if (window.outerWidth < 1024) {
        (0, _jquery2.default)('.js-recommendations').slick(options);
      } else if (recWrapper.classList.contains('slick-initialized')) {
        (0, _jquery2.default)('.js-recommendations').slick('unslick');
      }

      window.addEventListener('resize', function () {
        window.clearTimeout(timeout);
        timeout = window.setTimeout(_this2.mobileRecommendationsSlick, delay);
      });
    }
  }]);
  return Recommendations;
}();

exports.default = Recommendations;